export const ACTION_TYPES = {
  clearAll: 0,
  saveQuery: 1,
  applyFilters: 2,
  cancelQuery: 3,
};
